Ext.grid.CheckColumn = function(config) {
    Ext.apply(this, config);
    if (!this.id) {
        this.id = Ext.id();
    }
    this.renderer = this.renderer.createDelegate(this);
};

Ext.grid.CheckColumn.prototype = {
    init : function(grid) {
        this.grid = grid;
        this.grid.on('render', function() {
            var view = this.grid.getView();
            view.mainBody.on('mousedown', this.onMouseDown, this);
        }, this);
    },

    onMouseDown : function(e, t) {
        if (t.className && t.className.indexOf('x-grid3-cc-' + this.id) != -1) {
            e.stopEvent();
            var index = this.grid.getView().findRowIndex(t);
            var record = this.grid.store.getAt(index);
            var arr = record.data;
            arr[this.dataIndex] = !arr[this.dataIndex];
            if (record.store) {
                record.store.fireEvent("update", record.store, record, null /*no operation: store mustn't be affected*/);
            }
            if (this.handler) {
                this.handler.call(this, record.data[this.dataIndex], record);
            }
        }
    },

    renderer : function(v, p, record) {
        p.css += ' x-grid3-check-col-td';
        var cls = this.customCls || 'x-grid3-check-col';
        var tooltip = this.tooltip ? ' ext:qtip="' + this.tooltip + '"' : '';
        return '<div' + tooltip + ' class="' + cls + (v ? '-on' : '') + ' x-grid3-cc-' + this.id + '">&#160;</div>';
    }
};